module.exports = __webpack_public_path__ + "static/astronaut-pushing.f4be9038.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/astronaut-pushing.svg
// module id = 273
// module chunks = 89649133384338 275328729791212